import React from "react";
import { Dimmer } from "semantic-ui-react";
import mixpanel from "../../services/mixpanel";
import appIcon from "./assets/cm-logo.png";
import { getPlatformData, trackDownloadApp } from "./util";
import "./index.css";

const DownloadAppDialog = props => {
  const closeDialog = () => {
    props.closeDialog();
    mixpanel.track("downloadapp.dismiss");
  };
  const platformData = getPlatformData(props.mobileOS);
  return (
    <Dimmer active page>
      <div className="downloadapp">
        <div className="content">
          <div className="maincontent">
            <img src={appIcon} className={`logo ${platformData.appIconClassName}`} alt="Casemasters logo" />
            <div className="downloadfromstore">
              <div className="appname">Casemasters App</div>
              <div className="storename">
                <img src={platformData.storeIcon} className="storelogo" alt="App store icon" />
                <span>{`On the ${platformData.storeName}`}</span>
              </div>
            </div>
          </div>
          <div className="footer">
            <div className="footernote"> {`Stay up to date with our new ${platformData.platformName} app`} </div>
            <div className="continue" onClick={closeDialog}>
              Continue in browser
            </div>
            <a onClick={trackDownloadApp} href={platformData.appUrl} className="downloadbtn">
              Download now
            </a>
          </div>
        </div>
      </div>
    </Dimmer>
  );
};

export default DownloadAppDialog;



// WEBPACK FOOTER //
// ./src/components/DownloadAppDialog/index.js